var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIurcrowd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7289 0.60241L32.4699 6.24699L43.3133 12.488L38.988 14.9819L36.506 16.4157L32.1928 18.9096L26.9398 15.8976L21.6747 12.8855L13.6024 17.4699V12.5L21.6868 7.83133L22.7651 8.43373L29.1084 12.0964L32.2048 13.9036L34.6868 12.4699L30.3434 9.96386L21.6868 4.98193L13.0241 9.98193L11.1627 11.0542V31.0783L21.6506 37.1446L26.9157 34.1325L32.1687 31.1205V22.8253H43.3073V37.488L32.4639 43.741L21.6868 50L10.8434 43.741L0 37.488V20.3554L4.33133 17.8554V35L12.994 40L21.6868 45.006L30.3494 40.006L38.9759 35V27.1687H36.506V33.5542L29.0783 37.8434L21.6868 42.1325L6.80121 33.5542V8.56627L10.8434 6.24699L21.6868 0L22.759 0.60241H22.7289ZM0 17.506V12.494L4.33133 9.99398V15L0 17.506Z",
    fill: "#DCBA72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIurcrowd);
export default __webpack_public_path__ + "static/media/iurcrowd.ba1e2cb8d56db869bed6166f01d8a8aa.svg";
export { ForwardRef as ReactComponent };